import { Box, BoxProps, Stack } from "@mui/material";
import { ReactNode } from "react";

interface Props {
  /** E.g., cancel, save, etc. */
  primaryActions?: ReactNode;
  /** E.g., clear, rest, details, etc. */
  secondaryActions?: ReactNode;
  /** E.g., cancel, save, etc. */
  children?: ReactNode;
  sx?: BoxProps["sx"];
}

export default function AppPopoverActions({
  primaryActions,
  secondaryActions,
  children,
  sx,
}: Props) {
  return (
    <Stack
      direction='row'
      gap={1}
      sx={{
        alignItems: "center",
        justifyContent: "flex-end",
        ...sx,
      }}
    >
      {secondaryActions && <Box sx={{ mr: "auto" }}>{secondaryActions}</Box>}

      <Stack
        direction='row'
        gap={1}
        sx={{
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        {primaryActions || children}
      </Stack>
    </Stack>
  );
}
